import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_TO.USERS)({
    component: UsersLayout,
    staticData: {
        config: {
            breadcrumb: { title: "users", to: APP_ROUTES_TO.USERS },
            title: "users",
            layout: { scroll: false },
        },
        permissions: [PERMISSIONS.AUTH_SVC_USER_LIST],
    },
});

function UsersLayout() {
    return <Outlet />;
}
